/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Compare from './Compare/index'
import Delete from './Delete/index'
import Edit from './Edit/index'
import React from 'react'
import SendSecurely from './SendSecurely/index'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions",
  isHovered
  
}) {
let imageActionsValueData = fromData.useDataValue({ viewPath,
context: 'image_actions',
})
let patientImageSlotKeyValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'slot_key',
})
let authAccessTokenDataIsSupportValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
})
let appPropertiesAudaxCephEnabledValueData = fromData.useDataValue({ viewPath,
context: 'app_properties',
path: 'audax_ceph_enabled',
})
let aggregateData = fromHelpers.getThreeDotsMenu(imageActionsValueData, patientImageSlotKeyValueData, authAccessTokenDataIsSupportValueData, appPropertiesAudaxCephEnabledValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
  return (<React.Fragment
>
<div
  data-testid="Actions.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-AjnkD': isHovered ? 1 : 0}}
 className={`views-block ${styles.Vertical}`}
>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 data="image_actions"
 data="patient_image.slot_key"
 data="auth.access_token_data.is_support"
 data="app_properties.audax_ceph_enabled"
 aggregate="helpers.js getThreeDotsMenu"
 from={aggregateData}
 onClick={onClick}
/>
</div>
<SendSecurely
  viewPath={`${viewPath}/SendSecurely`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
<Compare
  viewPath={`${viewPath}/Compare`}
/>
{children}
</React.Fragment>)
}